import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Wordmark";
import { ROUTES } from "@/constants/routes";

export function AuthLayout({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-[5fr_7fr]">
      <aside className="relative hidden flex-col justify-between bg-ink p-12 lg:flex">
        <Wordmark to={ROUTES.home} inverted />
        <div className="max-w-sm">
          <p className="font-serif text-4xl leading-[1.1] text-[#F4F2EC]">Your professional identity, remembered.</p>
          <div className="mt-8 h-px w-16 bg-gold" />
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">MetWorth</p>
      </aside>
      <main className="flex flex-col px-6 py-8 sm:px-12">
        <div className="lg:hidden">
          <Wordmark to={ROUTES.home} />
        </div>
        <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-12">
          <p className="mw-eyebrow">{eyebrow}</p>
          <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">{subtitle}</p>}
          <div className="mt-10">{children}</div>
          {footer && <div className="mt-8 text-sm text-muted-foreground">{footer}</div>}
        </div>
      </main>
    </div>
  );
}

export function AuthFooterLink({ text, to, label, testId }) {
  return (
    <p>
      {text}{" "}
      <Link to={to} data-testid={testId} className="mw-link">
        {label}
      </Link>
    </p>
  );
}
